import { ReactElement } from "react";
import { MenuItem } from "@mui/material";
import { Check } from "@mui/icons-material";
import {
  useGetConfigurationQuery,
  usePostConfigurationMutation,
  usePutConfigurationByIdMutation,
} from "../../app/apislices/configurationApi";
import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";

export default function TimeZoneMenuItem(): ReactElement {
  const { data } = useGetConfigurationQuery(
    { name: "ist_utc", category: "konfig" },
    { selectFromResult: (result) => ({ ...result, data: result.data?.at(0) }) }
  );

  const [add] = usePostConfigurationMutation();
  const [update] = usePutConfigurationByIdMutation();

  dayjs.extend(tz);
  dayjs.tz.setDefault(data?.value === "true" ? "UTC" : undefined);

  return (
    <>
      <MenuItem
        dense
        onClick={() =>
          data?.isDefault
            ? add({ ...data, value: "false" })
            : update({ id: data!.id, configurationDto: { ...data!, value: "false" } })
        }
      >
        <Check color={data?.value === "false" ? "secondary" : "primary"} sx={{ marginRight: "10px" }} />
        Zeige Zeiten in lokaler Zeit
      </MenuItem>
      <MenuItem
        dense
        divider
        onClick={() =>
          data?.isDefault
            ? add({ ...data, value: "true" })
            : update({ id: data!.id, configurationDto: { ...data!, value: "true" } })
        }
      >
        <Check color={data?.value === "true" ? "secondary" : "primary"} sx={{ marginRight: "10px" }} />
        Zeige Zeiten in UTC
      </MenuItem>
    </>
  );
}
